import Api from "@/Api.js";

export default {

    loginWithFirebaseAccessToken(token){
        const url = '/api/user/firebase/login?accessToken='+token;
        return Api.get(url);
    },

    loginWithUsernamePassword(username,password){
        const url = '/api/secure/user/firebase/login';
        const options = {
          auth: {
            username: username,
            password: password
          }
        };
        return Api.get(url,options);
    },

     


}